import HomePage from "../pages/homePage/HomePage";
import Cart from "../components/cart/Cart";
import Ledger from "../components/ledger/Ledger";
import HelpAndSupport from "../components/helpSupport/HelpAndSupport";
import CustomerProfile from "../components/profileScreen/CustomerProfile";
import ProductListing from "../components/productListing/ProductListing";
import { ProductDetails } from "../components/productDetails/ProductDetails";
import MyOrders from "../components/myOrders/MyOrders";
import Prebookings from "../components/preBookings/PreBookings";
import OrderTracking from "../components/orderTracking/OrderTracking";
import Payment from "../components/payment/Payment";
import Wishlist from "../components/wishlist/Wishlist";
import OrderConfirmation from "../components/orderConfirmation/OrderConfirmation";

const customerRoutes = [
  { path: "maltora-customer/home", element: <HomePage /> },
  { path: "maltora-customer/cart", element: <Cart /> },
  { path: "maltora-customer/ledgers", element: <Ledger /> },
  { path: "maltora-customer/help-support", element: <HelpAndSupport /> },
  { path: "maltora-customer/customer-profile", element: <CustomerProfile /> },
  { path: "maltora-customer/products", element: <ProductListing /> },
  {
    path: "maltora-customer/products/product/:id",
    element: <ProductDetails />,
  },
  { path: "maltora-customer/my-orders", element: <MyOrders /> },
  { path: "maltora-customer/pre-bookings", element: <Prebookings /> },
  { path: "maltora-customer/order-tracking/:id", element: <OrderTracking /> },
  { path: "maltora-customer/my-orders/:id/payment", element: <Payment /> },
  { path: "maltora-customer/wishlist", element: <Wishlist /> },
  {
    path: "maltora-customer/order-confirmation/:id",
    element: <OrderConfirmation />,
  },
];

export default customerRoutes;
